import { Button, Header, Text } from '@rbilabs/universal-components';
import { spacing } from '@rbilabs/universal-components/themes';
import { useRouter } from 'expo-router';
import { Image, Pressable, StyleSheet, View } from 'react-native';

import { useIsMobileBreakpoint } from 'hooks/use-media-query';
import { primitive } from 'styles/constants/primitives';

const image = require('./mnt.png');

const MNT_URL = '/campaigns/mnt';

export const MntCard = () => {
  const isMobile = useIsMobileBreakpoint();
  const router = useRouter();

  const handlePress = () => {
    router.navigate(MNT_URL);
  };

  return (
    <View style={styles.container}>
      <Pressable onPress={handlePress}>
        <View style={styles.topContainer}>
          <View style={[styles.leftContainer, { width: isMobile ? spacing.$24 : spacing.$32 }]}>
            <Image style={{ width: 96, height: 96 }} source={image} />
          </View>
          <View style={styles.contentContainer}>
            <Header
              variant="headerThree"
              color={'token.text-default'}
              ellipsizeMode="tail"
              numberOfLines={2}
              mb="$1"
            >
              BK & Mexican National Team
            </Header>
            <View style={styles.offersDescription}>
              <View>
                <Text variant="copyTwo">Proud Sponsor of El Tricolor!</Text>
              </View>
              <View>
                <Text variant="copyTwo">
                  The Home of El Tricolor + BK is here! Visit for offers, chances to win and more!
                </Text>
              </View>
            </View>

            <Button
              variant="outline"
              size="sm"
              width="$24"
              onPress={handlePress}
              marginTop={{ base: '$2', md: '$4' }}
            >
              Get Started
            </Button>
          </View>
        </View>
      </Pressable>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: primitive.$white,
    borderRadius: 10,
    borderWidth: 0,
    flexDirection: 'column',
    marginVertical: spacing.$4,
  },
  topContainer: {
    width: '100%',
    padding: spacing.$2,
    flexDirection: 'row',
  },
  leftContainer: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  contentContainer: {
    flex: 1,
    padding: spacing.$2,
  },
  offersDescription: {
    justifyContent: 'space-between',
    gap: spacing.$6,
  },
});
